import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";

export function TransitionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Full Screen Background - 小女孩照片铺满 */}
      <div className="absolute inset-0">
        <motion.img
          src={images.past}
          alt="未来的希望"
          className="w-full h-full object-cover"
          initial={{ scale: 1.1, opacity: 0 }}
          animate={isInView ? { scale: 1, opacity: 1 } : { scale: 1.1, opacity: 0 }}
          transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content - 核心信息 */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={isInView ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, scale: 0.9, y: 30 }}
        transition={{ duration: 1, delay: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center px-6"
      >
        <p className="text-white text-xl md:text-3xl lg:text-4xl leading-relaxed tracking-wide drop-shadow-2xl max-w-3xl mx-auto">
          我们给予的
          <br />
          不只是生存
          <br />
          是一个值得梦想的未来
        </p>
        
        {/* 装饰元素 */}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
          transition={{ duration: 0.8, delay: 1.5 }}
          className="h-1 bg-gradient-to-r from-transparent via-white to-transparent mt-6 max-w-3xl mx-auto"
        />
      </motion.div>
    </section>
  );
}

